import { getDataLayerEnvironment } from './gtm/utils/getEnvironment';
import { DataLayerEntry, TrackingEvent, DataLayer } from './types';

export { getDataLayerEnvironment };

const environment = getDataLayerEnvironment();

export const getIsClientIdEvent = (obj: DataLayerEntry) => obj && Object.hasOwn(obj, 'clientId');
export const getIsGtmStartEvent = (obj: DataLayerEntry) =>
  obj && Object.hasOwn(obj, 'gtm.start') && obj.event === 'gtm.js';

export const setIsDataLayerSetupDone = (value: boolean) => {
  window.isDataLayerSetupDone = value;
};
export const getIsDataLayerSetupDone = () =>
  window.isDataLayerSetupDone === true || window.dataLayer?.some(ev => getIsGtmStartEvent(ev));

export const setupDataLayer = (): DataLayer => {
  window.dataLayer = window.dataLayer || ([] as unknown as DataLayer);
  const dataLayer = window.dataLayer;

  // DataLayer with a modified push function that queues added events until GTM is ready
  const originalPush = dataLayer.push;
  const queue: DataLayerEntry[] = [];
  let isGtmStartDone = getIsDataLayerSetupDone();
  dataLayer.push = (...args: DataLayerEntry[]) => {
    args.forEach(arg => {
      if (isGtmStartDone) {
        originalPush.call(dataLayer, arg);
      } else if (getIsGtmStartEvent(arg)) {
        isGtmStartDone = true;
        originalPush.call(dataLayer, arg);
        queue.forEach(item => originalPush.call(dataLayer, item));
        queue.length = 0;
        dataLayer.push = originalPush;
      } else if (getIsClientIdEvent(arg)) {
        originalPush.call(dataLayer, arg);
      } else {
        queue.push(arg);
      }
    });
    return dataLayer.length;
  };
  if (isGtmStartDone) return dataLayer;

  dataLayer.getQueueLength = () => queue.length;
  if (dataLayer.length) {
    const existingItems = dataLayer.slice(0);
    dataLayer.length = 0;
    existingItems.forEach(item => dataLayer!.push(item));
  }
  setIsDataLayerSetupDone(true);
  return dataLayer;
};

export const pushToDataLayer = (data: DataLayerEntry) => {
  const dataLayer = setupDataLayer();
  dataLayer.push({
    ...data,
    environment,
  });
};

export const keepFromTracking = (event?: TrackingEvent) => {
  if (!event) return;

  event._tracked = true;
};
